import pluralize from 'pluralize';

import { CARD_ELEMENT_TYPE } from '../../../cards/constants';

export const getCardPhotoElementsWithConfigurationFromAccountCard = ({
  accountCard,
}) => {
  if (!accountCard) {
    return [];
  }

  const accountCardSide = accountCard.account_card_sides?.[0];
  const cardSide = accountCardSide?.card_side;

  const photoCardElements = (
    cardSide?.card_template?.card_elements ?? []
  ).filter(element => element.type === CARD_ELEMENT_TYPE.PHOTO);

  return photoCardElements.map(elem => ({
    cardElement: elem,
    cardElementConfiguration:
      (accountCardSide?.card_element_configurations ?? []).find(
        config => config.card_element.id === elem.id,
      ) ??
      (cardSide?.card_element_configurations ?? []).find(
        config => config.card_element.id === elem.id,
      ),
  }));
};

// Builds a "<size> <product>" label for a package item, with an (n/m) suffix
// when the package holds the same product + size more than once.
export const getPrintProductItemLabel = ({
  printProducts,
  printProductItem,
}) => {
  if (
    !printProductItem?.printProductName ||
    !printProductItem?.printProductSizeName
  ) {
    return '';
  }

  const { printProductId, printProductSizeId } = printProductItem;
  const printProductGroup = printProducts.filter(
    product =>
      product.printProductId === printProductId &&
      product.printProductSizeId === printProductSizeId,
  );
  const printProductIndexPos = printProductGroup.indexOf(printProductItem);

  return `${printProductItem.printProductSizeName} ${pluralize(
    printProductItem.printProductName.replace(
      ' (configured as rendered sheets)',
      '',
    ),
    1,
  )}${
    printProductGroup.length > 1 && printProductIndexPos !== -1
      ? ` (${printProductIndexPos + 1}/${printProductGroup.length})`
      : ''
  }`;
};
